/**
 * This is a list of HTML data- attributes which prevent popular password managers from attaching their
 * extension icons to input fields.
 *
 * To use them - spread this object as props in the <input> which needs disabling.
 *
 * 1Password : https://developer.1password.com/docs/web/compatible-website-design/
 *
 * LastPass : https://support.lastpass.com/s/document-item?bundleId=lastpass&topicId=LastPass/c_lp_prevent_fields_from_being_filled_automatically.html&_LANG=enus
 *
 * Dashlane: https://stackoverflow.com/questions/59939931/stop-dashlane-auto-fill-on-specific-input-fields/68263873#68263873
 *
 * Bitwarden: https://github.com/bitwarden/clients/blob/e1415af407fef139fb69126349e5cc6d286f4474/apps/browser/src/autofill/services/collect-autofill-content.service.ts#L884-L889
 *
 * This list of HTML attributes could be updated when we gather more information on other password managers.
 */
export const PASSWORD_MANAGER_BLOCKING_HTML_ATTRIBUTES = {
    'data-1p-ignore': '',
    'data-lpignore': true,
    'data-form-type': 'other',
    'data-bwignore': '',
};
/**
 * Similar to the HTML attributes, some password managers require a class name in the input
 * for them to ignore it with their extensions
 *
 * To use - add this as a class name to the <input> you want to disable password managers for.
 *
 * Keeper: https://docs.keeper.io/user-guides/troubleshooting/website-developers
 *
 * If any other password managers are found that use class names for ignoring inputs, they
 * can be concatenated here
 */
export const PASSWORD_MANAGER_BLOCKING_CLASS_NAMES = 'keeper-ignore';
